import { render, staticRenderFns } from "./UserPickerConfig.vue?vue&type=template&id=04cc453a&scoped=true"
import script from "./UserPickerConfig.vue?vue&type=script&lang=js"
export * from "./UserPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc453a",
  null
  
)

export default component.exports